import actions from './actions';

const initState = {
    coupon   : {},
    loading : false,
    errorMessage: null
};

export default function createOrUpdateCouponReducer(state = initState, action) {
    switch (action.type) {
        case actions.CREATE_OR_UPDATE_COUPON_REQUESTED:
            return {
                ...state,
                coupon   : {},
                loading : true
            };
        case actions.CREATE_OR_UPDATE_COUPON_SUCCEEDED:

            return {
                ...state,
                coupon   : action.coupon,
                loading    : false
            };
        case actions.CREATE_OR_UPDATE_COUPON_FAILED:
            return {
                ...state,
                loading : false,
                errorMessage: action.error
            };
        default:
            return state;
    }
}
